import Vue from "vue";
import { checkResponse } from "@/helpers/store";

const state = {
  subscriberCardModal: false,
  subscriberCard: null
};

const mutations = {
  setSubscriberCardModal: (state, payload) =>
    (state.subscriberCardModal = payload),
  setSubscriberCard: (state, payload) => (state.subscriberCard = payload),
  clearSubscriberCard: state => (state.subscriberCard = null)
};

const actions = {
  async getSubscriberCard({ commit, rootState }, { abcode }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbgetclientcard",
            funcname: "getClientCard",
            abcode: `${abcode}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setSubscriberCard", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  }
};

const getters = {
  subscriberCardModal: state => state.subscriberCardModal,
  subscriberCard: state => state.subscriberCard
};

export default { state, mutations, actions, getters };
